import notification from 'notification-js';
import Config from 'config';
import Modal from '../node_modules/modal-js/dist/modal';
import Validator from 'validator';

export default class EditProfile {
  constructor(options) {
    this.onSubmit = options.onsubmit;

    let html = `<div class="edit-profile-modal">
      <form method="post">
        <div class="form-group">
            <label for="loginUsername">Username</label>
            <input type="text" class="form-control loginUsername" id="loginUsername" placeholder="Username">
        </div>
        <div class="form-group">
            <label for="firstname">Firstname</label>
            <input type="text" class="form-control firstname" id="firstname" placeholder="Firstname">
        </div>
        <div class="form-group">
            <label for="firstname">Surname</label>
            <input type="text" class="form-control surname" id="surname" placeholder="Surname">
        </div>
        <div class="form-group">
            <label for="email">Email</label>
            <input type="text" class="form-control email" id="email" placeholder="Email">
        </div>
        <div class="form-group">
          <input type="submit" name="submit" class='updateButton' value="Update" />
          <input type="button" name="cancel" class='cancelSubmitButton' value="Cancel" />
        </div>
      </form>
    </div>`;

    this.modal = new Modal({
      el: html,
      containerEl: document.getElementById('modals-container'),
      activeClass: 'modal-active',
      onShow: () => {},
      onHide: () => {},
      onClickOutside: (modal) => {
      }
    });
    this.modal.hide();

    this.loginUsername = this.modal.el.getElementsByClassName('loginUsername')[0];
    this.firstname = this.modal.el.getElementsByClassName('firstname')[0];
    this.surname = this.modal.el.getElementsByClassName('surname')[0];
    this.email = this.modal.el.getElementsByClassName('email')[0];
    this.cancelSubmitButton = this.modal.el.getElementsByClassName('cancelSubmitButton')[0];
    this.updateSubmitButton = this.modal.el.getElementsByClassName('updateButton')[0];

    this.cancelSubmitButton.onclick = function(event) {
      this.modal.hide();
    }.bind(this)

    this.updateSubmitButton.onclick = function(event) {
      event.preventDefault();
      var userData = {};

      if (this.validateForm()) {
        userData.username = this.loginUsername.value;
        userData.firstname = this.firstname.value;
        userData.surname = this.surname.value;
        userData.email = this.email.value;

        this.onSubmit(userData);
      }

    }.bind(this)
  }

  showEditProfile(data) {
    var body = document.body,
        html = document.documentElement;

    var height = Math.max( body.scrollHeight, body.offsetHeight,
                           html.clientHeight, html.scrollHeight, html.offsetHeight );

    this.modal.el.parentNode.style.height = height + 'px';
    this.loginUsername.value = data.username;
    this.firstname.value = data.firstname;
    this.surname.value = data.surname;
    this.email.value = data.email;

    this.modal.show();
  }

  hideEditProfile() {
    this.modal.hide();
  }

  validateForm() {

    if (Validator.isNull(this.loginUsername.value) ||
        Validator.isNull(this.firstname.value) ||
        Validator.isNull(this.surname.value) ||
        Validator.isNull(this.email.value)) {
      notification.notify( 'error', 'Please make sure all fields are entered', {
        notification: {position: [ 'right', 'top' ]}
      });
      return false;
    }

    if (!Validator.isEmail(email.value)) {
      notification.notify( 'error', 'Please enter a valid email address', {
        notification: {position: [ 'right', 'top' ]}
      });
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/EditProfile.js